'use client';
import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#6b705c', // sage-green
      light: '#8d9274',
      dark: '#4a4e40',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#470e08', // maroon
      light: '#6d3429',
      dark: '#320a05',
      contrastText: '#ffffff',
    },
    background: {
      default: '#eae5da', // off-white
      paper: '#ffffff',
    },
    text: {
      primary: '#1c1c1c', // black
      secondary: '#6c6c6c', // dark-grey
    },
    success: {
      main: '#2e7d32', // great-green
      light: '#adeb83', // green
      dark: '#1b5e20',
      contrastText: '#ffffff',
    },
    error: {
      main: '#ff2c2c', // red
      light: '#ff5721', // poor-red
      dark: '#d32f2f',
      contrastText: '#ffffff',
    },
    warning: {
      main: '#f9dbbd', // yellow
      light: '#fce4cc',
      dark: '#f57c00',
      contrastText: '#1c1c1c',
    },
    info: {
      main: '#a67b5b', // french-beige
      light: '#d4a574',
      dark: '#8b6914',
      contrastText: '#ffffff',
    },
    grey: {
      50: '#cdcdcd', // light-grey
      100: '#b1b1b1', // grey
      200: '#9e9e9e',
      300: '#757575',
      400: '#616161',
      500: '#6c6c6c', // dark-grey
      600: '#424242',
      700: '#303030',
      800: '#212121',
      900: '#1c1c1c', // black
    },
  },
  typography: {
    fontFamily: '"Raleway", "Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontFamily: '"Bodoni Moda", serif',
      fontSize: '42px', // xxl
      fontWeight: 600,
    },
    h2: {
      fontFamily: '"Bodoni Moda", serif',
      fontSize: '32px', // xl
      fontWeight: 600,
    },
    h3: {
      fontFamily: '"Bodoni Moda", serif',
      fontSize: '24px', // lg
      fontWeight: 600,
    },
    h4: {
      fontSize: '20px', // md
      fontWeight: 600,
    },
    h5: {
      fontSize: '16px', // sm
      fontWeight: 600,
    },
    h6: {
      fontSize: '12px', // xs
      fontWeight: 600,
    },
    body1: {
      fontSize: '16px', // sm
    },
    body2: {
      fontSize: '12px', // xs
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          fontFamily: '"Raleway", sans-serif',
          textTransform: 'none',
          borderRadius: '8px',
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: '12px',
          boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: '#6c6c6c !important',
            },
            '&:hover .MuiOutlinedInput-notchedOutline': {
              borderColor: '#6c6c6c !important',
            },
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
              borderColor: '#6c6c6c !important',
              borderWidth: '1px !important',
            },
            '&.Mui-error .MuiOutlinedInput-notchedOutline': {
              borderColor: '#ff2c2c !important',
            },
          },
          '& .MuiInputLabel-root': {
            color: '#1c1c1c !important',
            '&.Mui-focused': {
              color: '#1c1c1c !important',
            },
          },
          '& .MuiOutlinedInput-input': {
            color: '#1c1c1c !important',
            fontFamily: '"Raleway", sans-serif',
          },
          // Hide default password visibility toggle
          '& input[type="password"]::-ms-reveal': {
            display: 'none !important',
          },
          '& input[type="password"]::-webkit-textfield-decoration-container': {
            display: 'none !important',
          },
          '& input[type="password"]::-webkit-credentials-auto-fill-button': {
            display: 'none !important',
          },
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          '&.Mui-focused': {
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: '#6c6c6c !important',
              borderWidth: '1px !important',
            },
          },
          '&:hover': {
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: '#6c6c6c !important',
            },
          },
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: '#6c6c6c !important',
          },
        },
        notchedOutline: {
          borderColor: '#6c6c6c !important',
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          color: '#1c1c1c !important',
          '&.Mui-focused': {
            color: '#1c1c1c !important',
          },
        },
        outlined: {
          '&.Mui-focused': {
            color: '#1c1c1c !important',
          },
        },
      },
    },
  },
});

export default theme;